import { render } from "./AuthVeterinaire.vue?vue&type=template&id=343a4c40"
import script from "./AuthVeterinaire.vue?vue&type=script&lang=js"
export * from "./AuthVeterinaire.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__